import React from "react";
import Stepper from "../components/Stepper";

export const reviewsDialogColumns = [
  {
    name: "student_name",
    label: "Name",
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: "nps_score",
    label: "Rate",
    options: {
      filter: false,
      sort: false,
      setCellProps: () => ({ className: "custom-cell-class" }),
      customBodyRender: (value) => (
        <Stepper totalSteps={10} currentStep={value} />
      ),
    },
  },
  {
    name: "review",
    label: "Review",
    options: {
      filter: false,
      sort: false,
      setCellProps: () => ({ className: "vertical-text" }),
      customBodyRender: (value) => <span>{value ? value : "-"}</span>,
    },
  },
];

export const reviewsDialogOptions = {
  serverSide: true,
  rowsPerPageOptions: [],
  /*   rowsPerPage: schools.rowsPerPage,
  page: schools.page,
  count: schools.count, */
  rowHover: false,
  search: false,
  sort: false,
  print: false,
  filter: false,
  viewColumns: false,
  download: false,
  pagination: false,
  selectableRows: "none",
  /* tableBodyMaxHeight: isDesktop ? "50em" : "357px", */
  textLabels: {
    body: {
      noMatch: "No data",
    },
    pagination: {
      next: "Next",
      previous: "Previous",
      rowsPerPage: "Rows:",
      displayRows: "of",
    },
  },
};
